import React from 'react';
import {StyledGrid} from 'presentation/components';
import {Stack, Typography} from '@mui/material';
import {SelectCardList} from '../../styles';
import Icon from 'presentation/icons';
import {ALL_SPECIALTIES_KEY} from '../../hooks/useSpecialtyFilter';
import {SpecialtyListViewProps} from './types';

const SpecialtyListView = ({
	specialties,
	totalFavorites,
	specialtySelected,
	allSpecialtiesLabel,
	selectLabel,
	isMobile,
	colors,
	formatSpecialtyTitle,
	onSpecialtyClick,
}: SpecialtyListViewProps) => (
	<StyledGrid.Root
		p={isMobile ? 2 : 4}
		alignContent="flex-start"
		justifyContent="center"
		height="100%">
		{[
			<StyledGrid.Item key="all" sm={12} md={12} lg={8}>
				<SelectCardList
					elevation={0}
					selected={specialtySelected === ALL_SPECIALTIES_KEY}
					onClick={() => onSpecialtyClick(ALL_SPECIALTIES_KEY)}>
					<Stack
						gap={1}
						direction="row"
						justifyContent="space-between"
						width="100%"
						alignItems="center">
						<Typography variant="body2">
							{`${allSpecialtiesLabel} (${totalFavorites})`}
						</Typography>
						{isMobile ? (
							<Icon
								name="arrow-right"
								size={24}
								color={
									specialtySelected === ALL_SPECIALTIES_KEY
										? colors.light.success.main
										: colors.brand.primary.blue
								}
							/>
						) : (
							<Typography
								variant="button"
								color={
									specialtySelected === ALL_SPECIALTIES_KEY
										? colors.light.success.main
										: colors.brand.primary.blue
								}>
								{selectLabel}
							</Typography>
						)}
					</Stack>
				</SelectCardList>
			</StyledGrid.Item>,
			...specialties.map((specialty, index) => (
				<StyledGrid.Item key={index} sm={12} md={12} lg={8}>
					<SelectCardList
						elevation={0}
						selected={specialty.nmEspecialidade === specialtySelected}
						onClick={() =>
							onSpecialtyClick(
								specialty.nmEspecialidade,
								specialty.nmSubEspecialidade,
							)
						}>
						<Stack
							gap={1}
							direction="row"
							justifyContent="space-between"
							width="100%"
							alignItems="center">
							<Typography variant="body2">
								{formatSpecialtyTitle({
									specialtyName: specialty.nmEspecialidade,
									subSpecialtyName: specialty.nmSubEspecialidade,
									quantity: specialty.quantidadeProfissionaisPorEspecialidade,
								})}
							</Typography>
							{isMobile ? (
								<Icon
									name="arrow-right"
									size={24}
									color={
										specialty.nmEspecialidade === specialtySelected
											? colors.light.success.main
											: colors.brand.primary.blue
									}
								/>
							) : (
								<Typography
									variant="button"
									color={
										specialty.nmEspecialidade === specialtySelected
											? colors.light.success.main
											: colors.brand.primary.blue
									}>
									{selectLabel}
								</Typography>
							)}
						</Stack>
					</SelectCardList>
				</StyledGrid.Item>
			)),
		]}
	</StyledGrid.Root>
);

export {SpecialtyListView};
